import script from "./HeaderNav.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderNav.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderNav.vue?vue&type=style&index=0&id=50be3d8c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50be3d8c"]])

export default __exports__